// packages import
import { Menu, MenuItem } from '@mui/material'
import { FC, MouseEvent, useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// component import
import { ConfirmationModal } from '../common/ConfirmationModal'
import RecordPaymentModal from '../billing/billDetail/modal/RecordPayment'

// others
import { BillStatus } from '../../../generated'
import { FundRequestMenuProps } from '../../interfaceTypes'
import { AuthContext } from '../../context'
import { hasAdminAccess } from '../../utils'
import { useFundRequestActions } from '../../hooks/useFundRequestActions'

export const FundRequestMenu: FC<FundRequestMenuProps> = ({
  bill,
  clientId,
  caseId,
  billingType,
  clientPayableAmount,
  account,
  onRefetch,
  renderAction,
  hideViewOption
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const {
    // State
    showVoidConfirmation,
    setShowVoidConfirmation,
    showRecordPaymentModal,
    setShowRecordPaymentModal,
    voiding,
    archiving,
    sendingToClient,

    // Actions
    handleVoidBill,
    handleArchiveBill,
    handleSendBillToClient
  } = useFundRequestActions({
    onRefetch,
    onClose: () => setAnchorEl(null)
  })
  const { currentUser } = useContext(AuthContext)
  const navigate = useNavigate()

  const open = Boolean(anchorEl)

  const canSendBill = hasAdminAccess(currentUser) && bill?.sendToClient && bill?.status === BillStatus.Billed
  // const canRecordPayment =
  //   hasAdminAccess(currentUser) &&
  //   (bill?.status === BillStatus.Billed ||
  //     bill?.status === BillStatus.SentToClient ||
  //     bill?.status === BillStatus.PartiallyPaid)

  const canVoid =
    hasAdminAccess(currentUser) &&
    bill?.status !== BillStatus.Archived &&
    bill?.status !== BillStatus.Void &&
    bill?.status !== BillStatus.PartiallyPaid &&
    bill?.status !== BillStatus.Paid
  const canArchive =
    hasAdminAccess(currentUser) && (bill?.status === BillStatus.PartiallyPaid || bill?.status === BillStatus.Paid)

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleVoidClick = () => {
    handleClose()
    setShowVoidConfirmation(true)
  }

  const handleCancelVoid = () => {
    setShowVoidConfirmation(false)
  }

  const handleView = () => {
    if (bill?.id) {
      navigate(`/billing/fund-request-detail/${bill.id}`)
    }
    handleClose()
  }

  // const handleRecordPaymentClick = () => {
  //   handleClose()
  //   setShowRecordPaymentModal(true)
  // }

  const handleCloseRecordPaymentModal = () => {
    setShowRecordPaymentModal(false)
  }

  return (
    <>
      {renderAction(handleClick)}

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {!hideViewOption && <MenuItem onClick={handleView}>View</MenuItem>}

        {canSendBill && (
          <MenuItem onClick={() => handleSendBillToClient(bill?.id)} disabled={sendingToClient}>
            Send Bill
          </MenuItem>
        )}

        {/* {canRecordPayment && clientId && (
          <MenuItem onClick={handleRecordPaymentClick} disabled={!clientPayableAmount}>
            Record Payment
          </MenuItem>
        )} */}

        {canVoid && (
          <MenuItem onClick={handleVoidClick} disabled={voiding}>
            Void
          </MenuItem>
        )}

        {canArchive && (
          <MenuItem onClick={() => handleArchiveBill(bill?.id)} disabled={archiving}>
            Archive
          </MenuItem>
        )}
      </Menu>

      {showVoidConfirmation && (
        <ConfirmationModal
          isOpen={showVoidConfirmation}
          title="Void Fund Request"
          message={`Are you sure you want to void fund request #${bill?.id}? This action cannot be undone.`}
          confirmText="Void Fund Request"
          cancelText="Cancel"
          variant="danger"
          isLoading={voiding}
          onConfirm={() => handleVoidBill(bill?.id)}
          onCancel={handleCancelVoid}
        />
      )}

      {showRecordPaymentModal && clientId && (
        <RecordPaymentModal
          isOpen={showRecordPaymentModal}
          billId={bill.id}
          clientId={clientId}
          caseId={caseId}
          account={account}
          billingType={billingType}
          clientPayableAmount={clientPayableAmount}
          onClose={handleCloseRecordPaymentModal}
          onSuccess={onRefetch}
          isFundRequest
        />
      )}
    </>
  )
}
